import { Outlet, useParams } from "react-router-dom";
import { WeekendDTO } from "../dtos/WeekendDTO";
import { useEffect, useState } from "react";
import { Status } from "../lib/globalEnums";
import Spinner from "../components/Spinner";
import Sessions from "../components/Sessions";

export default function Weekend() {
  const { yearParam, weekendKey } = useParams();
  
  const [weekend] = useState(new WeekendDTO({
    year: yearParam,
    circuit_short_name	: weekendKey
  }))
  const [status, setStatus] = useState(Status.loading)
  useEffect(() => {
    setStatus(Status.loading)
    weekend.load(weekendKey).then(() => setStatus(Status.ready))
  }, [weekendKey, weekend])
  if (status === Status.loading) {
    return (
      <div>
        <Spinner />
      </div>
    );
  }
  return (
    <div>
      <div className="sticky-top w3-card w3-container w3-white w3-padding-bottom">
        <h2>{weekend.meeting_official_name}</h2>
        <div>{weekend.getHumanDate()}, {weekend.location}, {weekend.country_name}</div>
        <div>{weekend.getFullTime()}</div>
      </div>
      <div className="w3-container w3-margin-top w3-margin-bottom">
        <Sessions sessions={weekend.sessions} />
      </div>
      <Outlet />
    </div>
  );
}
